import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import { useGet } from "src/http-clients/clients";
import { getActiveApp } from "src/redux/selectors/app";

export const useGetProcurements = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeApp = useSelector(getActiveApp);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const endpoint = activeApp === "STORE" ? `created` : `received`;
  const data = useGet(`/users/procurement-request/${endpoint}${queryData}`);
  return data;
};
